<template>
  <v-container class="top-spacer">
    <div class="component-title">Configurações</div>
    <v-row>
      <v-col cols="12">
        <v-row>
          <!-- LEFT COLUMN -->
          <v-col class="subscription-col">
            <div class="card-label">Subscrição</div>
            <v-card class="custom-card">
              <!-- NOTIFICATIONS -->
              <v-row>
                <v-col class="settings-col">
                  <v-row>
                    <v-col class="settings-left-col">
                      <v-list-item two-line class="px-0">
                        <v-badge
                          overlap
                          bottom
                          content="+"
                          color="#D8E0E6"
                          class="big-badge"
                          offset-y="25"
                          offset-x="15"
                        >
                          <v-avatar
                            size="80"
                            class="avatar"
                            @click="
                              image = $lodash.cloneDeep(user.photo);
                              changePictureDialog = true;
                            "
                          >
                            <v-img :src="avatar"></v-img>
                          </v-avatar>
                        </v-badge>
                      </v-list-item>
                      <v-list-item two-line style="padding: 0 !important">
                        <v-list-item-content
                          style="padding-bottom: 0 !important"
                        >
                          <v-list-item-title class="user-title">{{
                            user.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle class="green-label">
                            <span>{{
                              isPremium()
                                ? "Utilizador premium"
                                : "Utilizador normal"
                            }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col>
                      <div class="gray-label">Duração</div>
                      <v-switch
                        inset
                        hide-details
                        label="Notificações de push da plataforma"
                        class="settings-switch"
                        style="margin-top: 8px !important"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <!-- BUTTONS -->
                  <v-row>
                    <v-col>
                      <!-- CHANGE PASSWORD -->
                      <v-dialog v-model="changePasswordDialog" max-width="349">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            large
                            depressed
                            color="#D8E0E6"
                            class="gray-button"
                            height="40"
                            width="180"
                            v-bind="attrs"
                            v-on="on"
                            >Alterar password</v-btn
                          >
                        </template>
                        <v-card>
                          <v-card-title align="center"
                            >Alterar password</v-card-title
                          >
                          <v-card-text
                            >Por questões de segurança iremos enviar-lhe um
                            email com um link onde poderá alterar a sua
                            password.</v-card-text
                          >
                          <v-list-item style="padding: 0 24px 12px 24px">
                            <v-list-item-content style="padding-right: 8px">
                              <v-btn
                                block
                                depressed
                                color="#D8E0E6"
                                class="gray-button"
                                height="48"
                                @click="changePasswordDialog = false"
                                >Cancelar</v-btn
                              >
                            </v-list-item-content>
                            <v-list-item-content style="padding-left: 8px">
                              <v-btn
                                large
                                depressed
                                dark
                                color="#26AB5E"
                                class="regular-btn"
                                height="40"
                                @click="resetPassword()"
                                >Confirmar</v-btn
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <!-- BIGODDS SUBSCRIPTION -->
              <v-row>
                <v-col class="settings-col">
                  <v-row>
                    <v-col style="padding: 0 12px">
                      <v-row>
                        <v-col class="settings-left-col">
                          <div class="green-label">Subscrição Bigodds</div>
                          <div class="big-black-value" style="margin-top: 8px">
                            {{
                              bigoddsIndex >= 0
                                ? this.user.subscriptions[bigoddsIndex].name
                                : "Sem subscrição"
                            }}
                          </div>
                        </v-col>
                        <v-col style="padding: 0 12px">
                          <v-row>
                            <v-col cols="4">
                              <div class="gray-label">Duração</div>
                              <div class="black-value">
                                {{
                                  bigoddsIndex >= 0
                                    ? getDuration(
                                        this.user.subscriptions[bigoddsIndex]
                                      ) + " dias"
                                    : "-"
                                }}
                              </div>
                            </v-col>
                            <v-col cols="6">
                              <div class="gray-label">Data de subscrição</div>
                              <div class="black-value">
                                {{
                                  bigoddsIndex >= 0
                                    ? $moment(
                                        this.user.subscriptions[bigoddsIndex]
                                          .startDate
                                      ).format("D MMM YYYY")
                                    : "-"
                                }}
                              </div>
                            </v-col>
                            <v-col cols="12" style="padding-top: 0">
                              <div class="gray-label">Tipo</div>
                              <div class="black-value">
                                {{
                                  bigoddsIndex >= 0
                                    ? "Utilizador premium"
                                    : "Free"
                                }}
                              </div>
                            </v-col>
                            <v-col cols="8">
                              <div class="gray-label">
                                Data limite
                                <span class="small-black-value">{{
                                  bigoddsIndex >= 0
                                    ? $moment(
                                        this.user.subscriptions[bigoddsIndex]
                                          .endDate
                                      ).format("D MMM YYYY")
                                    : "-"
                                }}</span>
                              </div>
                              <div>
                                <CustomProgressBar
                                  :percentage="
                                    bigoddsIndex >= 0
                                      ? getPercentage(
                                          this.user.subscriptions[bigoddsIndex]
                                        )
                                      : 0
                                  "
                                ></CustomProgressBar>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- BUTTONS -->
                  <v-row class="settings-btn-row">
                    <v-col>
                      <v-btn
                        v-if="bigoddsIndex < 0"
                        large
                        depressed
                        color="#D8E0E6"
                        class="gray-button"
                        height="40"
                        width="180"
                        :loading="loading"
                        @click="addSubscription()"
                        >Alterar subscrição</v-btn
                      >
                      <v-btn
                        v-else
                        block
                        large
                        depressed
                        color="secondary"
                        height="48"
                        @click="cancelPlanDialog = true; cancelIndex = bigoddsIndex;"
                        >Cancelar subscrição</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <!-- APPOSTA SUBSCRIPTION -->
              <v-row>
                <v-col class="settings-col">
                  <v-row>
                    <v-col style="padding: 0 12px">
                      <v-row>
                        <v-col class="settings-left-col">
                          <div class="green-label">Subscrição Apposta</div>
                          <div class="big-black-value" style="margin-top: 8px">
                            {{
                              appostaIndex >= 0
                                ? this.user.subscriptions[appostaIndex].name
                                : "Sem subscrição"
                            }}
                          </div>
                        </v-col>
                        <v-col style="padding: 0 12px">
                          <v-row>
                            <v-col cols="4">
                              <div class="gray-label">Duração</div>
                              <div class="black-value">
                                {{
                                  appostaIndex >= 0
                                    ? getDuration(
                                        this.user.subscriptions[appostaIndex]
                                      ) + " dias"
                                    : "-"
                                }}
                              </div>
                            </v-col>
                            <v-col cols="6">
                              <div class="gray-label">Data de subscrição</div>
                              <div
                                class="black-value"
                                style="text-transform: capitalize"
                              >
                                {{
                                  appostaIndex >= 0
                                    ? $moment(
                                        this.user.subscriptions[appostaIndex]
                                          .startDate
                                      ).format("D MMM YYYY")
                                    : "-"
                                }}
                              </div>
                            </v-col>
                            <v-col cols="12" style="padding-top: 0">
                              <div class="gray-label">Tipo</div>
                              <div class="black-value">
                                {{
                                  appostaIndex >= 0
                                    ? "Utilizador premium"
                                    : "Free"
                                }}
                              </div>
                            </v-col>
                            <v-col cols="8">
                              <div class="gray-label">
                                Data limite
                                <span
                                  class="small-black-value"
                                  style="text-transform: capitalize"
                                  >{{
                                    appostaIndex >= 0
                                      ? $moment(
                                          this.user.subscriptions[appostaIndex]
                                            .endDate
                                        ).format("D MMM YYYY")
                                      : "-"
                                  }}</span
                                >
                              </div>
                              <div>
                                <CustomProgressBar
                                  :percentage="
                                    appostaIndex >= 0
                                      ? getPercentage(
                                          this.user.subscriptions[appostaIndex]
                                        )
                                      : 0
                                  "
                                ></CustomProgressBar>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- BUTTONS -->
                  <v-row class="settings-btn-row">
                    <v-col>
                      <v-btn v-if="appostaIndex < 0"
                        large
                        depressed
                        color="#D8E0E6"
                        class="gray-button"
                        height="40"
                        width="180"
                        :loading="loading"
                        @click="addSubscription()"
                        >Alterar subscrição</v-btn
                      >
                      <v-btn
                          v-else
                          block
                          large
                          depressed
                          color="secondary"
                          height="48"
                          @click="cancelPlanDialog = true; cancelIndex = appostaIndex;"
                          >Cancelar subscrição</v-btn
                        >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <!-- REMOVE ACCOUNT -->
              <v-row style="background: #ebeff3; margin: 0">
                <v-col style="padding: 15px 24px">
                  <v-row>
                    <v-col class="small-black-value settings-remove-text"
                      >Ao apagar a sua conta estára a apagar todos os dados
                      pessoais e relativos às bancas e apostas</v-col
                    >
                    <v-spacer></v-spacer>
                    <v-col>
                      <!-- BUTTON / DIALOG -->
                      <v-dialog v-model="removeAccountDialog" max-width="349">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            large
                            depressed
                            dark
                            color="#F83030"
                            class="regular-btn"
                            height="40"
                            width="180"
                            v-bind="attrs"
                            v-on="on"
                            >Apagar conta</v-btn
                          >
                        </template>
                        <v-card>
                          <v-card-title
                            align="center"
                            style="color: #f83030 !important"
                            >Apagar conta</v-card-title
                          >
                          <v-card-text
                            >Ao apagar a sua conta apagará todos os dados
                            pessoais e relativos às bancas e aposta, no entanto,
                            as suas subscrições só cancelaram no fim do
                            prazo.</v-card-text
                          >
                          <v-list-item style="padding: 0 24px 12px 24px">
                            <v-list-item-content style="padding-right: 8px">
                              <v-btn
                                block
                                depressed
                                color="#D8E0E6"
                                class="gray-button"
                                height="48"
                                @click="removeAccountDialog = false"
                                >Cancelar</v-btn
                              >
                            </v-list-item-content>
                            <v-list-item-content style="padding-left: 8px">
                              <v-btn
                                large
                                depressed
                                dark
                                color="#F83030"
                                class="regular-btn"
                                height="40"
                                @click="removeAccount()"
                                >Apagar conta</v-btn
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- RIGHT COLUMN -->
          <v-col>
            <v-row>
              <v-col style="padding-top: 0 !important">
                <!-- GENERAL INFO -->
                <div class="card-label">Dados Gerais</div>
                <v-card>
                  <v-row>
                    <v-col class="settings-col settings-info">
                      <!-- Name -->
                      <v-row>
                        <v-col cols="12">
                          <div class="settings-label">Nome</div>
                          <v-text-field
                            :class="
                              bioDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.name"
                            height="48"
                            :disabled="bioDisabled"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Email & Birth-->
                      <v-row>
                        <v-col cols="7">
                          <div class="settings-label">Email</div>
                          <v-text-field
                            :class="
                              bioDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.email"
                            height="48"
                            :disabled="bioDisabled"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="user.bio">
                          <div class="settings-label">Data de nascimento</div>
                          <DatePicker
                            :date="computedBirth"
                            :disabled="bioDisabled"
                            @dateSelected="updateDate"
                          ></DatePicker>
                        </v-col>
                      </v-row>
                      <!-- Telephone & telegram -->
                      <v-row>
                        <v-col>
                          <div class="settings-label">Telefone</div>
                          <v-text-field
                            :class="
                              bioDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.bio.phone"
                            height="48"
                            :disabled="bioDisabled"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="7">
                          <div class="settings-label">Telegram user</div>
                          <v-text-field
                            :class="
                              bioDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.bio.telegramUser"
                            height="48"
                            :disabled="bioDisabled"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Button -->
                      <v-row>
                        <v-col>
                          <v-btn
                            large
                            depressed
                            :color="bioDisabled ? '#D8E0E6' : '#26AB5E'"
                            :class="bioDisabled ? 'gray-button' : 'green-btn'"
                            height="40"
                            width="180"
                            @click="updateBio()"
                            >{{ bioDisabled ? "Alterar" : "Guardar" }}</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <!-- ADDRESS INFO -->
                <div class="card-label">Dados de faturação</div>
                <v-card>
                  <v-row>
                    <v-col class="settings-col settings-info">
                      <!-- Address -->
                      <v-row>
                        <v-col>
                          <div class="settings-label">Morada</div>
                          <v-text-field
                            :class="
                              addressDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.billing.address"
                            height="48"
                            :disabled="addressDisabled"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Zip Code & City -->
                      <v-row>
                        <v-col>
                          <div class="settings-label">Código postal</div>
                          <v-text-field
                            :class="
                              addressDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.billing.zipCode"
                            height="48"
                            :disabled="addressDisabled"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="8">
                          <div class="settings-label">Cidade</div>
                          <v-text-field
                            :class="
                              addressDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.billing.city"
                            height="48"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Country -->
                      <v-row>
                        <v-col cols="8">
                          <div class="settings-label">País</div>
                          <v-text-field
                            :class="
                              addressDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.billing.country"
                            height="48"
                            :disabled="addressDisabled"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <div class="settings-label">NIF</div>
                          <v-text-field
                            :class="
                              addressDisabled
                                ? 'settings-text disabled'
                                : 'settings-text'
                            "
                            dense
                            filled
                            hide-details
                            v-model="user.billing.fiscalNumber"
                            height="48"
                            :disabled="addressDisabled"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-btn
                            large
                            depressed
                            :color="addressDisabled ? '#D8E0E6' : '#26AB5E'"
                            :class="
                              addressDisabled ? 'gray-button' : 'green-btn'
                            "
                            height="40"
                            width="180"
                            @click="updateAddress()"
                            >{{
                              addressDisabled ? "Alterar" : "Guardar"
                            }}</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div style="text-align: center; font-size: 11px; color: #bcc5cc !important">
      {{ $store.getters.appVersion }}
    </div>

    <!-- SUBSCRIPTIONS DIALOG -->
    <v-dialog v-model="subscriptionDialog" content-class="no-scroll">
      <v-card style="background-color: rgb(235, 239, 243)">
        <!-- Close X button -->
        <v-toolbar flat color="#EBEFF3">
          <v-btn
            icon
            @click="subscriptionDialog = false"
            class="close-btn"
            color="#9AABB8"
            height="40"
            width="40"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row style="margin-bottom: 48px">
          <v-col class="flex-center">
            <v-img
              src="../assets/images/logo.svg"
              max-width="94px"
              :style="selectedApposta ? 'opacity: 0.5;' : ''"
            ></v-img>
            <v-switch
              inset
              hide-details
              v-model="selectedApposta"
              class="dialog-switch plan-switch"
              style="margin: 0 8px 0 24px"
            ></v-switch>
            <v-img
              src="../assets/images/logo_apposta.svg"
              max-width="100px"
              :style="!selectedApposta ? 'opacity: 0.5;' : ''"
            ></v-img>
          </v-col>
        </v-row>
        <v-row
          style="flex-wrap: nowrap !important; overflow-x: scroll; margin: 0"
        >
          <v-col
            class="plan-col"
            v-for="(plan, index) in billingPlans"
            :key="'plan-' + index"
            :style="
              selectedApposta
                ? plan.name.toLowerCase().includes('bigodds')
                  ? 'display:none'
                  : ''
                : plan.name.toLowerCase().includes('apposta')
                ? 'display: none'
                : ''
            "
          >
            <SubscriptionPlanCard
              :plan="plan"
              @addSubscriptionPlan="addSubscriptionPlan($event)"
            ></SubscriptionPlanCard>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- CHANGE PROFILE PICTURE -->
    <v-dialog
      v-model="changePictureDialog"
      max-width="349"
      content-class="backoffice-dialog"
    >
      <v-card>
        <v-card-title align="center">Mudar imagem de perfil</v-card-title>
        <v-list-item style="padding: 0 24px 12px 24px">
          <v-list-item-avatar class="avatar" @click="countClicks()">
            <v-img :src="tempAvatar"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-text-field
              class="dialog-text"
              dense
              filled
              placeholder="Link da imagem"
              v-model="image"
              hide-details
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item style="padding: 0 24px 12px 24px">
          <v-list-item-content style="padding-right: 8px">
            <v-btn
              block
              depressed
              color="#D8E0E6"
              class="gray-button"
              height="48"
              @click="changePictureDialog = false"
              >Cancelar</v-btn
            >
          </v-list-item-content>
          <v-list-item-content style="padding-left: 8px">
            <v-btn
              large
              depressed
              dark
              color="#26AB5E"
              class="regular-btn"
              height="40"
              @click="changePicture()"
              >Confirmar</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <!-- CANCEL SUBSCRIPTION DIALOG -->
    <v-dialog v-model="cancelPlanDialog" max-width="349">
      <v-card>
        <v-card-title class="headline" align="center"
          >Cancelar subscrição {{this.computedCancelPlan}}?</v-card-title
        >
        <v-card-text
          >Tem a certeza que pretende cancelar a subscrição?</v-card-text
        >
        <v-list-item style="padding-bottom: 12px">
          <v-list-item-content style="padding-right: 8px">
            <v-btn
              block
              depressed
              color="secondary"
              height="48"
              :loading="loading"
              @click="cancelBillingPlan()"
              >Sim</v-btn
            >
          </v-list-item-content>
          <v-list-item-content style="padding-left: 8px">
            <v-btn
              block
              depressed
              color="primary"
              height="48"
              @click="cancelPlanDialog = false"
              >Não</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.value" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" :href="snackbar.link" target="_blank">
          <v-icon>{{ snackbar.icon }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style scoped>
.big-badge >>> .v-badge__badge {
  border-radius: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  font-size: 16px !important;
  padding: 5px 0 5px 1px !important;
  font-family: "Roboto";
  color: #9aabb8 !important;
}
.avatar:hover {
  cursor: pointer;
}
.dialog-text >>> .v-input__prepend-outer {
  display: none;
}
.dialog-text >>> .v-file-input__text--placeholder {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #bcc5cc !important;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e !important;
  padding-right: 4px;
  vertical-align: top;
}
.black-value {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351;
}
.big-black-value {
  font-family: Gilroy-SemiBold;
  font-size: 24px;
  line-height: 28px;
  color: #304351;
}
.small-black-value {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #6d818f;
}
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
}
.subscription-col {
  flex: 0 0 60%;
  max-width: 60%;
}
.settings-col {
  padding: 12px 36px;
  position: relative;
}
.settings-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
  margin-bottom: 4px;
}
.settings-info .row .col {
  padding: 4px 12px !important;
}
.settings-info .row:first-child .col {
  padding: 12px 12px 4px 12px !important;
}
.settings-info .row:last-child .col {
  padding: 20px 12px 12px 12px !important;
}
.settings-btn-row {
  position: absolute;
  bottom: 12px;
}
.settings-left-col {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}
.settings-remove-text {
  flex: 0 0 50%;
  max-width: 50%;
}
.theme--light.v-input--switch.plan-switch >>> .v-input--switch__track {
  color: rgba(38, 171, 94, 0.38) !important;
}
.theme--light.v-input--switch.plan-switch >>> .v-input--switch__thumb {
  color: #26ab5e;
}
@media only screen and (max-width: 768px) {
  .subscription-col,
  .settings-left-col,
  .settings-remove-text,
  .settings-info > .row > .col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .settings-btn-row {
    position: relative;
    bottom: 0;
  }
}
</style>

<script>
import store from "../store";
import { FirebaseApp } from "../auth";
import CustomProgressBar from "@/components/CustomProgressBar.vue";
import DatePicker from "@/components/DatePicker";
import SubscriptionPlanCard from "@/components/SubscriptionPlanCard";

import ApiService from "../services/api.service";
import AuthService from "../services/auth.service";
import DateTimeService from "@/services/datetime.service";

export default {
  name: "Settings",
  components: {
    CustomProgressBar,
    DatePicker,
    SubscriptionPlanCard,
  },
  data: () => ({
    user: {
      bio: {
        phone: ""
      },
      billing: {
        address: ""
      },
      subscriptions: []
    },
    image: "",
    durationBigodds: 0,
    remainingBigodds: 0,
    percentageBigodds: 0,
    removeAccountDialog: false,
    changePasswordDialog: false,
    changePictureDialog: false,
    bioDisabled: true,
    addressDisabled: true,
    bigoddsIndex: -1,
    appostaIndex: -1,
    cancelIndex: -1,
    loading: false,
    subscriptionDialog: false,
    cancelPlanDialog: false,
    billingPlans: [],
    billingPlan: {},
    selectedApposta: false,
    counter: 0,
    snackbar: {
      value: false,
      text: atob("RGV2ZWxvcGVkIGJ5OiBHb25jYWxvIEZvcnRl"),
      link: atob("aHR0cHM6Ly93d3cubGlua2VkaW4uY29tL2luL2dvbmNhbG9mb3J0ZS8="),
      icon: atob("bWRpLWxpbmtlZGlu"),
      timeout: 3000,
    },
  }),
  methods: {
    getUser() {
      ApiService.getUser().then(
        (response) => {
          this.user = response.data;
          this.getBigoddsIndex();
          this.getAppostaIndex();
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    updateBio() {
      if (!this.bioDisabled) {
        this.loading = true;
        ApiService.updateUser(this.user).then(
          (response) => {
            this.loading = false;
            this.getUser();
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      }
      this.bioDisabled = !this.bioDisabled;
    },
    updateAddress() {
      if (!this.addressDisabled) {
        this.loading = true;
        ApiService.updateUser(this.user).then(
          (response) => {
            this.loading = false;
            this.getUser();
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      }
      this.addressDisabled = !this.addressDisabled;
    },
    updateDate(date) {
      this.user.bio.birthDate = this.$moment(date).format("x");
    },
    deleteAccount() {
      console.log("Delete Account");
    },
    isPremium() {
      return this.$store.state.premium;
    },
    getDuration(subscription) {
      return DateTimeService.getDuration(
        subscription.startDate,
        subscription.endDate
      );
    },
    getPercentage(subscription) {
      return DateTimeService.getPercentage(
        subscription.startDate,
        subscription.endDate
      );
    },
    getBigoddsIndex() {
      this.bigoddsIndex = this.user.subscriptions.findIndex((x) =>
        x.app.toLowerCase().includes("bigodds")
      );
    },
    getAppostaIndex() {
      this.appostaIndex = this.user.subscriptions.findIndex((x) =>
        x.app.toLowerCase().includes("apposta")
      );
    },
    formatBirthDate(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },
    addSubscription() {
      this.getBillingPlans();
    },
    getBillingPlans() {
      this.loading = true;
      ApiService.getBillingPlans(this.user.billing.country).then(
        (response) => {
          this.billingPlans = response.data.plans;
          this.loading = false;
          this.subscriptionDialog = true;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getBillingPlanById(planId) {
      this.loading = true;
      ApiService.getBillingPlanById(planId).then(
        (response) => {
          this.billingPlan = this.$lodash.cloneDeep(response.data);
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    cancelBillingPlan() {
      this.loading = true;
      ApiService.cancelSubscription(this.user.subscriptions[this.cancelIndex].id).then(
        (response) => {
          this.loading = false;
          this.cancelPlanDialog = false;
          this.getUser();
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    addSubscriptionPlan(params) {
      const subscriptionId = params.subscriptionId;
      const planId = params.planId;

      ApiService.addSubscriptionPlan(subscriptionId, planId).then(
        (response) => {
          this.dialog = false;
          this.loading = false;
          this.getUser();
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    resetPassword() {
      const email = FirebaseApp.auth().currentUser.email;
      FirebaseApp.auth()
        .sendPasswordResetEmail(email)
        .then(() => {
          this.changePasswordDialog = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    removeAccount() {
      ApiService.deactivateUser().then(
        (response) => {
          AuthService.logout();
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    changePicture() {
      console.log("Change Picture");
      this.loading = true;
      ApiService.updatePicture(this.image).then(
        (response) => {
          this.getUser();
          store.commit("setUser", response.data);
          this.loading = false;
          this.changePictureDialog = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    countClicks() {
      this.counter++;

      if (this.counter == 5) {
        this.snackbar.value = true;
        this.counter = 0;
        setTimeout(() => {
          this.snackbar.value = false;
        }, 3000);
      }
      setTimeout(() => {
        this.counter = 0;
      }, 1000);
    },
  },
  created() {
    this.getUser();
  },
  computed: {
    avatar() {
      const photo = this.user.photo;
      if (photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }
    },
    tempAvatar() {
      const photo = this.image;
      if (photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }
    },
    computedBirth() {
      return this.$moment(this.user.bio.birthDate, "x").format("YYYY-MM-DD");
    },
    filteredPlans() {
      return this.billingPlans.filter((item) => {
        if (this.selectedApposta) {
          if (item.name.toLowerCase().includes("apposta")) {
            return item;
          }
        } else {
          if (item.name.toLowerCase().includes("bigodds")) {
            return item;
          }
        }
      });
    },
    computedCancelPlan() {
      return this.user.subscriptions[this.cancelIndex] ? this.user.subscriptions[this.cancelIndex].name : "";
    }
  },
};
</script>
